import React from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'

const UserRoute = ({ component: Component, accessToken, permission, ...rest }) => {
  if (!Component) return null
  try {
    return (
      <Route
        {...rest}
        render={(props) =>
          <Component permission={permission} {...props} /> 
        }
      />
    )
  } catch (error) {
    return console.error('USER ROUTE ERROR', error)
  }
}

const mapStateToProps = (state) => ({
  accessToken: state.auth.accessToken,
})
export default connect(mapStateToProps)(UserRoute)
